import { render, staticRenderFns } from "./ViewDetail.vue?vue&type=template&id=4327c4ea&scoped=true&"
import script from "./ViewDetail.vue?vue&type=script&lang=js&"
export * from "./ViewDetail.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=4327c4ea&prod&scoped=true&lang=css&"
import style1 from "../detail.css?vue&type=style&index=1&id=4327c4ea&prod&scoped=true&lang=css&"
import style2 from "./ViewDetail.vue?vue&type=style&index=2&id=4327c4ea&prod&scoped=true&lang=css&"
import style3 from "./ViewDetail.vue?vue&type=style&index=3&id=4327c4ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4327c4ea",
  null
  
)

export default component.exports